
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flux-2-ai-image-generator",
      function () {
        return require("private-next-pages/flux-2-ai-image-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flux-2-ai-image-generator"])
      });
    }
  